import { CommissionsRequestInterface } from '../../../interfaces/request/commissions/commissions-request-interface';

export class CommissionsRequestModel implements CommissionsRequestInterface {
  liquidationDateStart: string = '';
  liquidationDateEnd: string = this.liquidationDateStart || '';
  paymentDateStart: string = '';
  paymentDateEnd: string = this.paymentDateStart || '';
  page: number | undefined;
  pageSize: number | undefined;

  constructor(init?: Partial<CommissionsRequestModel>) {
    Object.assign(this, init);
  }
}
